// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2jyJB","rootSuccess":"CompleteLink_rootSuccess__TlIW7","rootFailure":"CompleteLink_rootFailure__1RKAo","isDisabled":"CompleteLink_isDisabled__TFwSr"};